import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPaintBucket: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="paint-bucket, design, color, appearance"><path d="M19.25 21.25V10C19.25 5.99594 16.0041 2.75 12 2.75C7.99594 2.75 4.75 5.99594 4.75 10V21.25H19.25Z" stroke="currentColor" strokeWidth="1.5"/><path d="M8.75 9.5V15" stroke="currentColor" strokeWidth="1.5"/><path d="M11.75 10V13" stroke="currentColor" strokeWidth="1.5"/><path d="M3 9.25H21" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconPaintBucket;
